/**
 * User-facing copy for skills document upload rejections.
 *
 * The first three are shown from two places under different conditions — the browser-side guard in
 * `DocumentDropzone`, and the API's rejection `reason` in `useSkillInference` for callers that reach
 * the endpoint without passing that guard. They live here so a reword cannot silently apply to only
 * one of those paths.
 */
export const INVALID_FILE_TYPE_COPY = 'This document is not a valid file type. Please select a PDF, DOCX, or TXT file.';
export const EMPTY_FILE_COPY = 'This file appears to be empty. Please select a different file.';
export const FILE_TOO_LARGE_COPY = 'This file is too large. Please select a file that is under 10 MB.';

/**
 * API-only: extraction produced too little usable text to infer skills from — a scanned or
 * image-only PDF (which yields whitespace), or a document under the API's readable-character floor
 * (`SKILL_INFERENCE_MIN_TEXT_LENGTH`, default 100, measured after PII redaction, so a page of
 * nothing but contact details falls under it too). All arrive as `empty_document_text`.
 */
export const UNREADABLE_DOCUMENT_COPY = 'We couldn\'t read any text from this document. If it\'s a scanned image, please upload a text-based version.';

/** API-only: the file's content does not match the type it was declared as. */
export const UNOPENABLE_DOCUMENT_COPY = 'We couldn\'t open this file. Please make sure it is a valid PDF, DOCX, or TXT document.';

/** Fallback for any rejection we have no specific copy for. */
export const GENERIC_UPLOAD_FAILURE_COPY = 'Something went wrong! Please try again.';
